 <div class="gutter">

	<header #header class="flx-col flx-gap-default">
			<h1 #headerTitle *ngIf="page.title">{{ page.title }}</h1>
			<div *ngIf="page.content">
				<app-ve [content]="page.content"></app-ve>
			</div>
	</header>
	
	<div *ngIf="loading$ | async" class="flx-row flx-cntr-cntr"><span class="loader-circle"></span></div>
	<div class="flx-row flx-wrap-grid flx-wrap-grid flx-wrap-grid-2-sm flx-wrap-grid-3-md">
		<div *ngFor="let post of (posts$ | async); let i = index" >
			<div class="post flx-col hoverable">
				<div class="square-wrap">
					<div class="badges">
						<span class="badge">{{ post.date_created | date:'mediumDate' }}</span>
					</div>
					<img *ngIf="post.photos.length" [src]="cdn+'/socials/'+post.id+'/'+post.photos[0]">
				</div>
				<div class="message" [innerHtml]="post.message"></div>
			</div>		
		</div>
	</div>
</div>